import { Language as GQLLanguage } from '../../__generated__/graphql';
import { Language } from '../constants/i18n';

export const toGQLLanguage = (language?: string): GQLLanguage =>
  language?.toUpperCase() === GQLLanguage.Fr ? GQLLanguage.Fr : GQLLanguage.En;

export const fromGQLLanguage = (language: GQLLanguage): Language =>
  language === GQLLanguage.Fr ? Language.Fr : Language.En;
